import React, { useState, useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '@components/common/Loader/newLoaderModal';
import StagePaymentComp from '@components/StagePayment/indexCopy';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import Modal from '@components/common/Modal';
import SwipeComponent from '../PaymentTerminalStagePayment/SwipeComponent';
import {
  setSeat,
  updateWithPaymentStages,
  removeWithPaymentStages,
  setPaymentCheck,
} from '@reducers/orders';
import { setNotification } from '@reducers/notification';
import { openEmployeeCheck, setScreenSaverStatus } from '@reducers/oauth';
import { flowType } from '@utility/userInfo';
import EventEmitter from '@utility/eventSubscribers';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import { findIndex } from 'lodash';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import arrowDown from '@assets/images/arrowDown.svg';
import cross from '@assets/images/receipt_cross.svg';
import PaymentImg from '@assets/images/Payment152.png';
import PaymentImg_white from '@assets/images/PaymentImg_white.png';
import { ReactComponent as LockIcon } from '@assets/images/Lock.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import cn from 'classnames';

const StagePayment = props => {
  // Props Destructuring

  const { seat, deviceInfo, serverAppTheme, paymentLandscapeOrientation} = props;

  //State Management

  const isServerApp = flowType() === 'serverApp';
  const countryCode = getObjectValue(
    () => COUNTRY_CODE[props.auth.country].dialCode,
    '1'
  );
  const isDefaultMode = getObjectValue(
    () =>
      !deviceInfo.deviceGroup || [0].includes(deviceInfo.deviceGroup.startMode),
    false
  );
  const lockPaymentScreen = getObjectValue(
    () => props.auth.serverAppFeatures.lockPaymentScreen && isDefaultMode,
    false
  );
  const [selectedStage, setSelectedStage] = useState();
  const [selectedStageIndex, setSelectedStageIndex] = useState();
  const isCounter = getObjectValue(
    () => isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  const isDriveThru = getObjectValue(() => isServerApp && [3].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props?.deviceInfo?.deviceGroup?.startMode), false);
  const ShowLandscapeMode =
    isServerApp &&
    paymentLandscapeOrientation;
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const paymentType = Number(urlSearchParams('screenType')) || 1;
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const isLandScape = window.innerWidth > window.innerHeight;
  const tableData = props.seat;
  const getTheme = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme
  );

  // React Hooks

  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
      if ((isServerApp || isTableTop) && (!isCounter || !isDriveThru || !isCallCenter)) {
        if (
          !paymentLandscapeOrientation
        ) {
          EventEmitter.changeOrientation({
            orientation: 'portrait',
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (sortedSeatItemHashTable) {
      setSelectedStage(sortedSeatItemHashTable[0]);
      setSelectedStageIndex(0);
    }
    props.setScreenSaverStatus(false);
  }, []);

  //Methods

  const sortStages = data => {
    return data.sort((a, b) => a.status - b.status);
  };

  const getTotalAmount = amount => {
    return Number(amount) > 0 ? +amount.toFixed(2) : 0;
  };

  const getSubTotalAmount = table => {
    return props.auth.country === 4
      ? +(table.subTotalAmount - table.taxAmount)
      : +table.subTotalAmount;
  };

  const seatItemHashTable = {};
  let priorTotalAmount = 0;
  const isAllSeatsStaged = (() => {
    const seatIds = seat.seats.reduce((a, v) => {
      if (v.open) {
        a.push(v.id);
      }
      return a;
    }, []);
    const paymentStagesSeats = seat.paymentStages.reduce((a, v) => {
      if (v.status === 0 && v?.seats?.length > 0) {
        v.seats.forEach(({ seatId }) => a.push(seatId));
      }
      return a;
    }, []);
    return paymentStagesSeats.length === seatIds.length;
  })();
  seat.paymentStages.forEach((paymentStageData, i) => {
    const itemsArray = [];
    let subTotalAmount = 0;
    let serviceChargeAmount = 0;
    let discountAmount = 0;
    seat.items.forEach(it => {
      let price = 0;
      let flag = false;
      let count = 0;
      paymentStageData.seats.forEach(nSeat => {
        const index = findIndex(it.seats, d => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          count += 1;
          price += it.seats[index].splitAmount;
        }
      });
      if (flag) {
        subTotalAmount += price;
        itemsArray.push({
          ...it,
          oldPrice: it.price,
          price,
          splitValueString:
            count === it.seats.length ? '' : `${count}/${it.seats.length} `,
          splitValue: count === it.seats.length ? 1 : count + 1,
        });
      }
    });
    seat.serviceCharges.forEach(serviceCharge => {
      let serviceChargeValue = 0;
      let flag = false;
      paymentStageData.seats.forEach(nSeat => {
        const index = findIndex(
          serviceCharge.seats,
          d => d.seatId === nSeat.seatId
        );
        if (index !== -1) {
          flag = true;
          serviceChargeValue += serviceCharge.seats[index].splitAmount;
        }
      });
      if (flag) {
        serviceChargeAmount += serviceChargeValue;
      }
    });
    seat.discounts.forEach(discount => {
      let discountValue = 0;
      let flag = false;
      paymentStageData.seats.forEach(nSeat => {
        const index = findIndex(discount.seats, d => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          discountValue += discount.seats[index].splitAmount;
        }
      });
      if (flag) {
        discountAmount += discountValue;
      }
    });
    const taxAmt = +((subTotalAmount * seat.taxAmount) / seat.itemAmount);
    const lastStageTaxAmount = +(
      seat?.unpaidAmount -
      priorTotalAmount -
      subTotalAmount +
      discountAmount
    );
    const taxAmount =
      isAllSeatsStaged &&
      i === seat.paymentStages.length - 1 &&
      lastStageTaxAmount > 0
        ? +lastStageTaxAmount
        : +taxAmt;
    const totalAmount =
      countryCode === '44'
        ? getTotalAmount(
            +(subTotalAmount + serviceChargeAmount - discountAmount)
          )
        : getTotalAmount(
            +(taxAmount + subTotalAmount + serviceChargeAmount - discountAmount)
          );
    if (paymentStageData.status === 0) {
      priorTotalAmount += totalAmount;
    }
    seatItemHashTable[paymentStageData.id] = {
      paymentStageId: paymentStageData.id,
      items: itemsArray,
      taxAmount,
      subTotalAmount,
      stage: paymentStageData,
      status: paymentStageData.status,
      totalAmount,
      unpaidAmount: +(
        taxAmount +
        subTotalAmount +
        serviceChargeAmount -
        discountAmount
      ).toFixed(2),
      seats: seat.seats.reduce((a, v) => {
        if (paymentStageData.seats.some(d => d.seatId === v.id)) {
          a.push({ ...v });
        }
        return a;
      }, []),
      paidAmount: 0,
      serviceChargeAmount: +serviceChargeAmount.toFixed(2),
      discountAmount: +discountAmount.toFixed(2),
    };
  });

  const onClickPaymentHandler = paymentInfo => {
    if (Object.values(seatItemHashTable).find(e => e.unpaidAmount < 0)) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().NEGATIVE_BALANCE,
      });
    } else {
      props.setSeat({
        ...seat,
        stageData: paymentInfo,
        totalAmount: paymentInfo.totalAmount,
      });
      props
        .setPaymentCheck({
          ...seat,
          ...paymentInfo,
          subTotalAmount: getSubTotalAmount(paymentInfo),
        })
        .then(() => {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${seat.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=stage`,
          });
        });
    }
  };

  const handleRouteToCheckListing = () => {
    if (!lockPaymentScreen) {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
      if (window.ReactNativeWebView && (isServerApp || isTableTop)) {
        EventEmitter.changeOrientation({
          orientation: 'landscape',
        });
      }
    } else {
      props.openEmployeeCheck();
    }
  };

  const sortedSeatItemHashTable =
    Object.values(seatItemHashTable).length > 0 &&
    sortStages(Object.values(seatItemHashTable));

  const onSwipedLeft = () => {
    if (selectedStageIndex === sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex]);
      setSelectedStageIndex(selectedStageIndex);
    } else if (selectedStageIndex < sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex + 1]);
      setSelectedStageIndex(selectedStageIndex + 1);
    }
  };

  const onSwipedRight = () => {
    if (selectedStageIndex === 0) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex]);
      setSelectedStageIndex(selectedStageIndex);
    } else if (selectedStageIndex <= sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex - 1]);
      setSelectedStageIndex(selectedStageIndex - 1);
    }
  };

  const handleLock = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
  };

  const prevCheck = () => {
    if (selectedStageIndex > 0) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex - 1]);
      setSelectedStageIndex(selectedStageIndex - 1);
    }
  };

  const nextCheck = () => {
    if (selectedStageIndex < sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex + 1]);
      setSelectedStageIndex(selectedStageIndex + 1);
    }
  };

  const renderModifier = modifiersObj =>
    (modifiersObj || []).map(modifier => (
      <div
        key={modifier.modifierId}
        className={
          modifier.price ? 'col-12 text-left pl-20 pr-0 fs-12' : 'd-none'
        }
      >
        {`${modifier.quantity > 1 ? `${modifier.quantity} x ` : ''} ${
          modifier.modifierName
        }`}
        <span className="float-right">
          $
          {modifier.price ? `${currenySymbol}${modifier.price.toFixed(2)}` : ''}
        </span>
        {(modifier.note || modifier.comment) && (
          <div className="pl-2">{modifier.note || modifier.comment}</div>
        )}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="pl-2">{renderModifier(modifier.modifiers)}</div>
        )}
      </div>
    ));

  const taxAmoutWithTotal =
    (isCounter || isDriveThru || isCallCenter) && Number(urlSearchParams('screenType')) === 16
      ? Number(tableData?.totalAmount) + Number(tableData?.taxAmount)
      : tableData.totalAmount;

  // HTML CSS CODE

  return (
    <div
      className="d-flex mb-4 h-100"
      style={{
        fontFamily: 'Poppins',
        overflowY: 'hidden',
        backgroundColor: serverAppTheme?.background_color,
        color: serverAppTheme?.primary_text,
      }}
    >
      {props.loading && <Loader />}
      <div className="col-12 p-3 h-100">
        <div
          style={{ height: '4.4%' }}
          className="d-flex align-items-center pb-1"
        >
          <div
            className={cn(
              'col-12 d-flex justify-content-center align-items-center fs_26 fw-600'
            )}
          >
            <span>
              {' '}
              {LABEL().TABLE}{' '}
              {props?.seat?.stationName ||
                props?.seat?.name ||
                props?.seat?.stationNumber}
            </span>
          </div>
          <div
            className={cn(
              ' position-fixed d-flex justify-content-center align-items-center rounded'
            )}
            style={{
              right: '1rem',
              top: '1rem',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: props.serverAppTheme.iconcolor_bg_box,
            }}
            role="presentation"
            onClick={() => handleRouteToCheckListing()}
          >
            {!lockPaymentScreen ? (
              <Cross
                fill={props.serverAppTheme?.iconcolor}
                width={24}
                height={24}
              />
            ) : (
              <LockIcon fill={props.serverAppTheme?.iconcolor} />
            )}
          </div>
        </div>
        {selectedStage && (
          <SwipeComponent
            title="Carousel"
            onSwipedLeft={onSwipedLeft}
            onSwipedRight={onSwipedRight}
          >
            <div
              style={{ overflow: 'hidden' }}
              className={cn(
                'row mx-0 position-relative w-100',
                paymentType === 2
                  ? 'h-18'
                  : [1].includes(paymentType)
                  ? 'h-18'
                  : 'h-16'
              )}
            >
              <div className="w-100 h-100 position-relative py-1 mt-1">
                <img
                  src={
                    !props.auth?.imageUrl
                      ? props.auth?.imageUrl
                      : getTheme === '2'
                      ? PaymentImg_white
                      : PaymentImg
                  }
                  className={cn('w-100 h-100 position-absolute')}
                  style={{
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    minWidth: '100%',
                    minHeight: '100%',
                  }}
                  alt=" "
                />
              </div>
              <div></div>
            </div>

            <div
              key={selectedStage.paymentStageId}
              className={cn(
                ShowLandscapeMode
                  ? 'col-12 row py-2 h-60'
                  : 'col-12 px-0 pt-2 h-82'
              )}
            >
              {seat.items && seat.items.length > 0 && (
                <Modal
                  isOpen={viewDetailsOpen}
                  isModalCenter
                  customClass="h-100 w-100 text-white"
                  customClass2="h-100 mt-0 maxW-100"
                  style={{
                    height: '100%',
                    backgroundColor: '#292C2D',
                    fontFamily: 'Poppins',
                  }}
                >
                  <div className="h-100 w-100 od-text-primary text-white">
                    <div
                      style={{
                        backgroundColor: '#292C2D',
                        position: 'relative',
                      }}
                      className="h-96 m-3"
                    >
                      <div className="row mx-0 h-8 flex-column w-100">
                        <div className="d-flex align-items-center pb-2">
                          <div
                            className={cn(
                              'col-11 d-flex justify-content-center align-items-center'
                            )}
                          >
                            <span style={{ marginLeft: '50px' }}>
                              {' '}
                              {LABEL().TABLE}{' '}
                              {props?.seat?.stationName ||
                                props?.seat?.name ||
                                props?.seat?.stationNumber}
                            </span>
                          </div>
                          <div className="col-1 d-flex justify-content-center align-items-end">
                            <img
                              src={cross}
                              alt="cross"
                              onClick={() => {
                                setViewDetailsOpen(false);
                              }}
                              tabIndex="0"
                              role="button"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <img
                          className="float-right"
                          style={{ paddingRight: '13px' }}
                          src={arrowDown}
                          alt="cross"
                        />
                      </div>
                      <div className="mx-0 h-85 overflowY flex-column w-100 pt-2">
                        <div
                          className={cn(
                            'col-12 text-light h-2 row mx-0 w-100 align-content-center fw-500 fs-14'
                          )}
                          style={{ fontFamily: 'Poppins' }}
                        >
                          <div className="col-1 p-0 text-left">
                            {' '}
                            <span> {LABEL().QTY}</span>
                          </div>
                          <div className="col-7 p-0 text-left">
                            <div className="mx-0">{LABEL().ITEMS_LIST}</div>
                          </div>
                          <div className="col-1 p-0 text-left">
                            {' '}
                            <span> Seats</span>
                          </div>
                          <div className={cn('col-3 p-0 text-right')}>
                            <span>{LABEL().AMOUNT}</span>
                          </div>
                        </div>
                        <hr
                          style={{
                            borderTop: '1px solid #4C4C4C',
                            margin: '10px 10px 10px 10px',
                          }}
                        />
                        <div className="overflowY">
                          {seat.items &&
                            seat.items.map(item => {
                              item;
                              return (
                                <>
                                  <div
                                    key={item.menuItemId}
                                    className={cn(
                                      'col-12 row mx-0 mt-1 py-1 w-100 align-content-center'
                                    )}
                                  >
                                    <div className="col-1 p-0 text-left">
                                      {' '}
                                      <span> {item.quantity}</span>
                                    </div>
                                    <div className="col-7 p-0 text-left">
                                      <div className="mx-0">
                                        {[2, 17, 23].includes(paymentType) &&
                                        !['payType', 'null', 'credit'].includes(
                                          'payType'
                                        ) ? (
                                          <span
                                            className={cn(
                                              'p-0 fs-16',
                                              item.quantity > 1 ||
                                                seat.splitValue > 1
                                                ? 'col-4'
                                                : ''
                                            )}
                                          >
                                            {`${
                                              item.quantity > 1 ||
                                              seat.splitValue > 1
                                                ? `${item.quantity}${
                                                    seat.splitValue > 1
                                                      ? `/${seat.splitValue} `
                                                      : ''
                                                  }x `
                                                : ''
                                            }`}
                                            {`${item.splitValueString}${item.menuItemName}`}
                                          </span>
                                        ) : (
                                          <span
                                            className={cn(
                                              'p-0',
                                              item.quantity > 1 ||
                                                seat.splitValue > 1
                                                ? ''
                                                : 'col-11'
                                            )}
                                          >
                                            {item.quantity > 1
                                              ? item.quantity + ' x '
                                              : ''}{' '}
                                            {item.menuItemName}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    {item?.seats ? (
                                      <div className="col-1 px-0 h-8 d-flex justify-content-center align-items-center">
                                        <div className="bg-white fs-14 fw-500 color-black w-80 h-100 rounded d-flex justify-content-center align-items-center">
                                          {item?.seats?.length > 1
                                            ? '1/' + item?.seats?.length
                                            : seat?.seats?.filter(
                                                i =>
                                                  i?.id ===
                                                  item?.seats[0]?.seatId
                                              )[0]?.number}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="col-1 px-0 h-8 d-flex justify-content-center align-items-center">
                                        <div className="bg-white fs-14 fw-500 color-black w-80 h-100 rounded d-flex justify-content-center align-items-center">
                                          {item?.seatIds?.length > 1
                                            ? '1/' + item?.seatIds?.length
                                            : props?.check?.seats?.filter(
                                                i => i?.id === item?.seatIds[0]
                                              )[0]?.number}
                                        </div>
                                      </div>
                                    )}
                                    <div className={cn('col-3 p-0 text-right')}>
                                      {currenySymbol}
                                      {item.price.toFixed(2)}
                                    </div>
                                    <div className="col-12 p-0">
                                      {item.modifiers &&
                                        renderModifier(item.modifiers)}
                                    </div>
                                  </div>

                                  <hr
                                    style={{
                                      borderTop: '1px solid #4C4C4C',
                                      margin: '10px 10px 10px 10px',
                                    }}
                                  />
                                </>
                              );
                            })}
                        </div>

                        {/* subtotal box */}
                        <div
                          style={{
                            bottom: '0',
                            left: '0',
                            width: '100%',
                            position: 'fixed',
                          }}
                        >
                          <div
                            style={{ fontSize: '14px' }}
                            className={cn(
                              isLandScape
                                ? 'col-12 border-color-primary od-text-primary overflowY mx-0 px-0 p-2'
                                : 'col-12 border-color-primary od-text-primary overflowY mx-0 px-0 p-3',
                              'justify-items-center fw-400 rounded',
                              ShowLandscapeMode ||
                                ([23].includes(paymentType) && 'h-auto')
                            )}
                          >
                            {countryCode === '44' ? (
                              <div className="row m-0 fw-600 fs-14">
                                <div className="col-8 p-0 text-left">
                                  {LABEL().PAYEMENT_TOTAL_DUE}
                                </div>
                                {Number(urlSearchParams('screenType')) === 5 ? (
                                  <div className="col-4 p-0 text-right">
                                    {currenySymbol}
                                  </div>
                                ) : (
                                  <div className="col-4 p-0 text-right">
                                    {currenySymbol}
                                    {(seat.totalAmount ||
                                      seat.totalAmount === 0) &&
                                    countryCode != 44
                                      ? taxAmoutWithTotal.toFixed(2)
                                      : Number(
                                          urlSearchParams('screenType')
                                        ) !== 17
                                      ? urlSearchParams('type') != 'payType'
                                        ? Number(
                                            urlSearchParams('screenType')
                                          ) === 1
                                          ? (
                                              taxAmoutWithTotal + seat.taxAmount
                                            ).toFixed(2)
                                          : taxAmoutWithTotal.toFixed(2)
                                        : (
                                            taxAmoutWithTotal + seat.taxAmount
                                          ).toFixed(2)
                                      : Number(
                                          urlSearchParams('screenType')
                                        ) === 17
                                      ? taxAmoutWithTotal.toFixed(2)
                                      : (
                                          taxAmoutWithTotal + seat.taxAmount
                                        ).toFixed(2)}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className={cn('row mx-0 fw-600 fs-18')}>
                                <div className={cn('col-6 p-0 text-left')}>
                                  {LABEL().SUB_TOTAL}
                                </div>

                                <div
                                  className={cn(
                                    'col-6 p-0 text-right fs-16 fw-600'
                                  )}
                                >
                                  {currenySymbol}
                                  {(seat.subTotalAmount ||
                                    seat.subTotalAmount === 0) &&
                                    seat.subTotalAmount.toFixed(2)}
                                </div>
                              </div>
                            )}
                            <div className="row mx-0 ">
                              <div
                                className={cn(
                                  'col-6 p-0 text-left justify-items-center fw-400 rounded'
                                )}
                                style={{ fontSize: '14px' }}
                              >
                                {countryCode === '44'
                                  ? LABEL().VAT
                                  : LABEL().TAX}
                              </div>
                              <div
                                style={{ fontSize: '14px' }}
                                className={cn(
                                  'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                )}
                              >
                                {currenySymbol}
                                {(seat.taxAmount || seat.taxAmount === 0) &&
                                  seat.taxAmount.toFixed(2)}
                              </div>
                            </div>
                            {seat?.discountAmount > 0 && (
                              <div className="row mx-0 fw-700 fs-18">
                                <div className="col-6 p-0 text-left">
                                  {LABEL().DISCOUNT_AMOUNT}
                                </div>
                                <div
                                  className={cn(
                                    'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                  )}
                                  style={{ fontSize: '14px' }}
                                >
                                  -{currenySymbol}
                                  {seat?.discountAmount.toFixed(2)}
                                </div>
                              </div>
                            )}
                            {seat?.serviceChargeAmount > 0 && (
                              <div className="row mx-0 fw-700 fs-18">
                                <div className="col-6 p-0 text-left">
                                  {LABEL().SERVICE_CHARGE}
                                </div>
                                <div
                                  className={cn(
                                    'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                  )}
                                  style={{ fontSize: '14px' }}
                                >
                                  {currenySymbol}
                                  {seat?.serviceChargeAmount.toFixed(2)}
                                </div>
                              </div>
                            )}
                            {[1, 20, 17].includes(paymentType) &&
                              getObjectValue(() => tipAmount > 0, false) && (
                                <div className="row m-0 fw-700 fs-18">
                                  <div
                                    className={cn(
                                      'col-6 p-0 text-left justify-items-center fw-400 rounded'
                                    )}
                                    style={{ fontSize: '14px' }}
                                  >
                                    {LABEL().TIP}
                                  </div>
                                  <div
                                    className={cn(
                                      'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                    )}
                                    style={{ fontSize: '14px' }}
                                  >
                                    {currenySymbol}
                                    {(tipAmount &&
                                      Number(tipAmount).toFixed(2)) ||
                                      (seat && seat.tipAmount.toFixed(2))}
                                  </div>
                                </div>
                              )}
                            {countryCode !== '44' &&
                              ![20, 17, 18].includes(paymentType) && (
                                <div className="row mx-0 align-items-center">
                                  <div
                                    className={cn(
                                      'col-6 p-0 text-left fw-600 fs-14'
                                    )}
                                  >
                                    {LABEL().PAYEMENT_TOTAL_DUE}
                                  </div>
                                  <div
                                    className={cn(
                                      'col-6 p-0 text-right fs-18 fw-600'
                                    )}
                                  >
                                    {currenySymbol}
                                    {(seat.totalAmount ||
                                      seat.totalAmount === 0) &&
                                      seat.totalAmount.toFixed(2)}
                                  </div>
                                </div>
                              )}
                            {getObjectValue(() => seat.paidAmount > 0, false) &&
                              ![5].includes(paymentType) && (
                                <div className="row m-0 fw-700 fs-18">
                                  <div
                                    className={cn(
                                      'col-6 p-0 text-left justify-items-center fw-400 rounded'
                                    )}
                                    style={{ fontSize: '14px' }}
                                  >
                                    {LABEL().TOTAL_PAID}
                                  </div>
                                  <div
                                    className={cn(
                                      'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                    )}
                                    style={{ fontSize: '14px' }}
                                  >
                                    {currenySymbol}
                                    {seat.paidAmount.toFixed(2)}
                                  </div>
                                </div>
                              )}
                            {getObjectValue(() => paidTips > 0, false) &&
                              [1, 2, 10, 9].includes(paymentType) && (
                                <div className="row m-0 fw-700 fs-18">
                                  <div className="col-6 p-0 text-left">
                                    {LABEL().PAID_TIPS}{' '}
                                  </div>
                                  <div className={cn('col-6 p-0 text-right')}>
                                    {currenySymbol}
                                    {Number(paidTips).toFixed(2)}
                                  </div>
                                </div>
                              )}
                            {getObjectValue(() => unpaidTips > 0, false) &&
                              [1, 2, 10, 9].includes(paymentType) && (
                                <div className="row m-0 fw-700 fs-18">
                                  <div className="col-6 p-0 text-left">
                                    {LABEL().UNPAID_TIPS}{' '}
                                  </div>
                                  <div
                                    style={{ fontSize: '14px' }}
                                    className={cn(
                                      'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                    )}
                                  >
                                    {currenySymbol}
                                    {Number(unpaidTips).toFixed(2)}
                                  </div>
                                </div>
                              )}
                            {[2, 5, 6, 11, 12].includes(paymentType) &&
                              props.paymentFlowType === 4 &&
                              getObjectValue(() => tipAmount > 0, false) && (
                                <div className="row m-0 fw-700 fs-18">
                                  <div
                                    style={{ fontSize: '14px' }}
                                    className={cn(
                                      'col-6 p-0 text-left justify-items-center fw-400 rounded'
                                    )}
                                  >
                                    {LABEL().TIP}
                                  </div>
                                  <div className={cn('col-6 p-0 text-right')}>
                                    {currenySymbol}
                                    {(tipAmount &&
                                      Number(tipAmount).toFixed(2)) ||
                                      (seat && seat.tipAmount.toFixed(2))}
                                  </div>
                                </div>
                              )}
                            {[2, 3, 4, 5, 6, 11, 12].includes(paymentType) &&
                              props.paymentFlowType === 3 &&
                              getObjectValue(() => tipAmount > 0, false) && (
                                <div className="row m-0 fw-700 fs-18">
                                  <div className="col-6 p-0 text-left">
                                    {LABEL().TIP}{' '}
                                  </div>
                                  <div
                                    style={{ fontSize: '14px' }}
                                    className={cn(
                                      'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                    )}
                                  >
                                    {currenySymbol}
                                    {(tipAmount &&
                                      Number(tipAmount).toFixed(2)) ||
                                      (seat && seat.tipAmount.toFixed(2))}
                                  </div>
                                </div>
                              )}
                            {[23].includes(paymentType) ? (
                              <div className="row m-0 fw-700 fs-18">
                                <div
                                  style={{ fontSize: '14px' }}
                                  className={cn(
                                    'col-6 p-0 text-left justify-items-center fw-400 rounded'
                                  )}
                                >
                                  {LABEL().TIP}
                                </div>
                                <div
                                  className={cn(
                                    'col-6 p-0 text-right justify-items-center fw-400 rounded'
                                  )}
                                  style={{ fontSize: '14px' }}
                                >
                                  {currenySymbol}
                                  {(tipAmount &&
                                    Number(tipAmount).toFixed(2)) ||
                                    (seat && seat.tipAmount.toFixed(2))}
                                </div>
                              </div>
                            ) : null}

                            {[5, 6, 11].includes(paymentType) && (
                              <div className="row m-0 fw-700 fs-18">
                                <div className="col-6 p-0 text-left">
                                  {LABEL().PAYMENT}{' '}
                                </div>
                                {countryCode === '44' &&
                                Number(urlSearchParams('screenType')) === 5 ? (
                                  <div className="col-4 p-0 text-right">
                                    {currenySymbol}
                                    {seat && seat.totalAmount.toFixed(2)}
                                  </div>
                                ) : (
                                  <div className="col-4 p-0 text-right">
                                    {currenySymbol}
                                    {seat &&
                                      (
                                        seat.totalAmount + Number(tipAmount)
                                      ).toFixed(2)}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          {/* subtotal box ends */}
                          <button
                            id="btnItemisd"
                            className={cn(
                              'col-12 btn-ripple py-4 rounded-top border-0 od-btn-primary fs-30 h-8 text-white'
                            )}
                            style={{
                              backgroundColor: '#0060FF',
                              width: '100%',
                            }}
                            onClick={() => {
                              setViewDetailsOpen(false);
                            }}
                          >
                            {LABEL().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              )}
              <div
                className={cn(
                  'col-12 row mx-0 w-100 align-content-center fw-500 fs-18 px-2 mb-2'
                )}
                style={{
                  fontFamily: 'Poppins',
                  color: serverAppTheme?.secondary_text,
                  height: '4%',
                }}
              >
                <div className="col-1 p-0 text-left">
                  {' '}
                  <span> {LABEL().QTY}</span>
                </div>
                <div className="col-7 p-0 text-left">
                  <div style={{ paddingLeft: '0.5rem' }} className="mx-0">
                    {LABEL().ITEMS_LIST}
                  </div>
                </div>
                <div className="col-1 p-0 text-left">
                  {' '}
                  <span> Seat</span>
                </div>
                <div className={cn('col-3 p-0 text-right')}>
                  <span style={{ paddingRight: '0.5rem' }}>
                    {LABEL().AMOUNT}
                  </span>
                </div>
              </div>
              <StagePaymentComp
                stageData={selectedStage.stage}
                auth={props.auth}
                tableData={seat}
                stageInfo={selectedStage}
                seatItems={selectedStage.items}
                currencySymbol={LABEL().CURRENCY_SYMBOL}
                countryCode={countryCode}
                onClickPaymentHandler={onClickPaymentHandler}
                allMenuItems={props.menuItems}
                selectedStageIndex={selectedStageIndex}
                sortedSeatItemHashTable={sortedSeatItemHashTable}
                prevCheck={prevCheck}
                nextCheck={nextCheck}
                ShowLandscapeMode={ShowLandscapeMode}
                seat={props.seat}
                serverAppTheme={serverAppTheme}
              />
            </div>
          </SwipeComponent>
        )}
      </div>
      {props.isEmployeeCheck && (
        <EmployeeCheck
          {...props}
          callBack={() => {
            handleLock();
          }}
          caseType={flowType()}
        />
      )}
    </div>
  );
};

// Redux Part

const mapStateToProps = state => ({
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  position: state.orders.position,
  loading: state.stage.loading || state.orders.loading,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
  menuItems: state.orders.menuItems,
  serverAppTheme: state.theme.serverAppTheme,
  paymentLandscapeOrientation: state.payment.paymentLandscapeOrientation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNotification,
      updateWithPaymentStages,
      removeWithPaymentStages,
      setPaymentCheck,
      openEmployeeCheck,
      setSeat,
      setScreenSaverStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StagePayment);
